import { Component, Input, OnInit } from '@angular/core';
import { OnDestroy } from '@angular/core';
import { ComponentBase } from 'src/app/views/component-base';
import { CurrencyPipe, NgIf } from '@angular/common';
import { SuperFundModel } from 'src/app/model/superfund.model';


@Component({
    selector: 'app-rollin-review-card',
    templateUrl: './rollin-review-card.component.html',
    styleUrls: ['./rollin-review-card.component.scss'],
    imports: [
        NgIf,
        CurrencyPipe
    ],
})
export class RollinReviewCardComponent extends ComponentBase implements OnInit, OnDestroy {
    @Input() set rollin(value: SuperFundModel) {
        this._rollin = value;
    }

    _rollin:SuperFundModel = null;

    constructor() {
        super();
    }

    async ngOnInit() {
        super.ngOnInitBase();
    }

    ngOnDestroy(): void {
        super.ngOnDestroyBase();
    }
}
